module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminempresas/adminempresas.component.scss
// module id = ./src/app/adminempresas/adminempresas.component.scss
// module chunks = main